export const RESPONSIVE_BREAKPOINTS = {
	sm: 480,
	md: 768,
	lg: 1024,
	xl: 1280,
	xxl: 1440,
} as const;

export type TResponsiveBreakpoint =
	| "mobile"
	| "tablet"
	| "laptop"
	| "desktop"
	| "wide";

export const RESPONSIVE_MEDIA = {
	mobile: `(max-width: ${RESPONSIVE_BREAKPOINTS.md - 1}px)`,
	tablet: `(min-width: ${RESPONSIVE_BREAKPOINTS.md}px) and (max-width: ${
		RESPONSIVE_BREAKPOINTS.lg - 1
	}px)`,
	tabletDown: `(max-width: ${
		RESPONSIVE_BREAKPOINTS.lg - 1
	}px)`,
	laptop: `(min-width: ${RESPONSIVE_BREAKPOINTS.lg}px) and (max-width: ${
		RESPONSIVE_BREAKPOINTS.xl - 1
	}px)`,
	desktop: `(min-width: ${RESPONSIVE_BREAKPOINTS.xl}px)`,
	wide: `(min-width: ${RESPONSIVE_BREAKPOINTS.xxl}px)`,
} as const;

export const getResponsiveBreakpoint = (
	width: number
): TResponsiveBreakpoint => {
	if (width < RESPONSIVE_BREAKPOINTS.md) return "mobile";
	if (width < RESPONSIVE_BREAKPOINTS.lg) return "tablet";
	if (width < RESPONSIVE_BREAKPOINTS.xl) return "laptop";
	if (width < RESPONSIVE_BREAKPOINTS.xxl) return "desktop";
	return "wide";
};
